import { render, staticRenderFns } from "./LanguageCommunication.vue?vue&type=template&id=0833a31e&scoped=true"
import script from "./LanguageCommunication.vue?vue&type=script&lang=ts"
export * from "./LanguageCommunication.vue?vue&type=script&lang=ts"
import style0 from "./LanguageCommunication.vue?vue&type=style&index=0&id=0833a31e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833a31e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0833a31e')) {
      api.createRecord('0833a31e', component.options)
    } else {
      api.reload('0833a31e', component.options)
    }
    module.hot.accept("./LanguageCommunication.vue?vue&type=template&id=0833a31e&scoped=true", function () {
      api.rerender('0833a31e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/LanguageCommunication.vue"
export default component.exports